import Admin from "../Admin";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";
import CardAdminModifierCodeList from "../../../Component/Card/Admin/ModifierCode/CardAdminModifierCodeList";

export default class ModifierCodeList extends Admin {
  /**
   * Render the content.
   */
  renderContent() {
    return <CardAdminModifierCodeList />;
  }

  /**
   * Render the header.
   */
  renderHeader() {
    const handleClickCreate = () => {
      this.props.history.push({
        pathname: "/admin/modifierCode",
      });
    };

    const buttons = [
      <MUIButton
        component="label"
        variant="contained"
        startIcon={<MUIAddIcon />}
        onClick={handleClickCreate}
      >
        Create New
      </MUIButton>,
    ];

    return <PageHeader title="Modifier Codes" buttons={buttons} />;
  }
}
